import React, { Component } from 'react';
import { Graph, GraphArgs, GraphNode } from '@trlogic/ui-pack';
import CaseService from '../../service/CaseService';
import ServiceContainer from '../../config/ServiceContainer';
import { ServiceNames } from '../../constant/ServiceNames';
import GraphNodeInformationComponent from './GraphNodeInformationComponent';
import { FormicaProps, withFormica } from 'helpers/withFormica';
import { createPortal } from 'react-dom';
import Icon from 'icons/Icon';
import { GraphConfiguration, GraphInformationJsonModel, GraphNodeInformationConfiguration } from '../../domain/graph/GraphDomains';
import { query } from '@trlogic/client-js';
import { CaseGraphField, CaseSettings } from '../../domain/case/CaseDomains';
import { cloneDeep } from 'lodash';
import { GraphExportJob } from '../../domain/job/JobDomain';
import moment from 'moment/moment';
import MessageUtil from '../../util/MessageUtil';
import JobService from '../../service/JobService';
import { TransactionData, TransactionRiskType } from '../../domain/stream/transaction/TransactionDomains';
import SuspiciousActivityReportSidebarComponent from '../sar/SuspiciousActivityReportSidebarComponent';
import CustomLoading from '../custom/CustomLoading';
import { RootState } from '../../redux/store';
import { ComponentState } from '../../redux/actions/ComponentActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import Filter = query.Filter;
import LanguageUtil from '../../util/LanguageUtil';

class CaseGraphComponent extends Component<Props, State> {
  public state = new State();

  private caseService: CaseService = ServiceContainer.getInstance().get(ServiceNames.CASE);
  private readonly jobService: JobService = ServiceContainer.getInstance().get(ServiceNames.JOB);

  private containerRef = React.createRef<HTMLDivElement>();

  public render() {
    const { data, reportLoading, reportVisible, transactionData } = this.state;
    const {
      domain,
      riskType,
      component: { module },
    } = this.props;
    return (
      <div
        style={{ boxShadow: '2px 2px 15px 0px #0000000D' }}
        ref={this.containerRef}
        className={`w-full flex flex-col bg-[#FFFFFF] h-[416px] border-[#E0E4E8] border-[1px] rounded-[10px] overflow-hidden relative`}
      >
        <span className='flex flex-row h-[50px] shrink-0 w-full justify-between items-center px-5  border-b-[1px] border-[#E0E4E8] rounded-t-[10px] bg-[#F9FAFB]'>
          <div className={'text-primary'}>{LanguageUtil.get({ id: 'pages.case.detail.header.graphAnalytics' })}</div>
          <div className={'flex gap-x-2 items-center'}>
            {data != undefined && riskType == 'compliance' && module.includes('aml') && (
              <div
                onClick={this.onReport}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] min-w-[28px] h-[28px] flex items-center justify-center bg-white hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
              >
                {reportLoading ? (
                  <div className={'w-[16px] h-[16px]'}>
                    <CustomLoading />
                  </div>
                ) : (
                  <Icon icon={'sar-icon'} size={14} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                )}
              </div>
            )}
            <div
              onClick={this.goGraph}
              className='cursor-pointer relative group border rounded border-[#E0E4E8] min-w-[28px] h-[28px] flex items-center justify-center bg-white hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
            >
              <Icon
                icon={'full-screen-open'}
                size={20}
                color={'#4F4F4F'}
                className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'}
              />
            </div>
            <div
              onClick={this.onExport}
              className='cursor-pointer relative group border rounded border-[#E0E4E8] min-w-[28px] h-[28px] flex items-center justify-center bg-white hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
            >
              <Icon icon={'export'} size={16} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
            </div>
          </div>
        </span>
        {data ? (
          <Graph
            data={data}
            args={
              {
                onClickNode: this.onClickNode as any,
                width: this.containerRef.current?.clientWidth || 364,
                height: this.containerRef.current?.clientHeight || 364,
                quality: window.devicePixelRatio,
                antialias: false,
                webGlPreference: 'low-power',
              } as GraphArgs
            }
          />
        ) : (
          <div className={'flex flex-col items-center justify-center w-full min-h-[364px] bg-white gap-5 px-5 py-5 rounded-b-[10px]'}>
            <div className={'flex items-center w-40 h-40 justify-center rounded-full bg-secondary'}>
              <section className={'flex items-center w-32 h-32 justify-center rounded-full bg-white drop-shadow'}>
                <Icon icon={'sidebar-graph'} className={'text-[#728EFF]'} size={45} />
              </section>
            </div>
            <section className={'flex flex-col items-center justify-center gap-y-2 select-none'}>
              <div className={'text-f-black-2 2xl'}>
                {LanguageUtil.get({ id: 'pages.case.detail.header.graphnotConfiguredYet' })}
                <strong className={'cursor-pointer'} onClick={this.goConfiguration}>
                  {LanguageUtil.get({ id: 'pages.case.detail.header.click' })}
                </strong>
                {LanguageUtil.get({ id: 'pages.case.detail.header.toConfigure' })}
              </div>
            </section>
          </div>
        )}
        {this.state.informationVisible &&
          createPortal(
            <GraphNodeInformationComponent
              visible={this.state.informationVisible}
              onChangeVisible={this.onChangeInformationVisible}
              isCasePage={true}
              coordinates={this.state.coordinates}
              currencyConfiguration={this.props.currencyConfiguration}
              nodeInformationJsonModel={this.state.selectedNode}
            />,
            document.body,
          )}
        {this.getGraphMapKey()}
        <SuspiciousActivityReportSidebarComponent
          visible={reportVisible}
          data={transactionData}
          sarConfiguration={domain?.suspiciousActivityReport}
          onClose={() => this.setState({ reportVisible: false })}
        />
      </div>
    );
  }

  public componentDidMount() {
    this.executeGraph();
  }

  private onClickNode = async (event: any, node: GraphNode) => {
    const { transaction } = this.props;
    const { x, y } = event.client;
    let _x = event.client.x,
      _y = event.client.y;
    if (500 - y < 0) {
      _y -= 230;
    }
    if (x + 500 > window.innerWidth) {
      _x -= 500;
    }
    const nodeInformationRequest: GraphNodeInformationConfiguration = {
      transaction: transaction,
      key: node.key?.split('-')[0],
      transactionAmountField: this.props.transactionAmountField || 'amount',
      filter: {
        filterType: 'ConditionalFilter',
        type: 'and',
        filters: [
          {
            filterType: 'MatchFilter',
            key: 'variables.' + node.key?.split('-')[0] + '.keyword',
            value: node.label,
            type: 'eq',
          },
        ],
      } as Filter,
    };
    const response = await this.caseService.getNodeInformation(nodeInformationRequest);
    const nodeInformation: GraphInformationJsonModel = {
      nodeInfo: response,
      node: node as any,
    };
    this.setState({ coordinates: { x: _x, y: _y } });
    this.setState({ selectedNode: nodeInformation, informationVisible: true });
  };

  private executeGraph = async () => {
    const { transaction, filter, groups } = this.props;
    const request: GraphConfiguration = {
      transaction: transaction,
      groups: groups,
      nodeLimit: 50,
      filter: filter,
      defaultFilterKeys: [],
    };
    this.caseService.executeGraph(request as any)?.then((data: any) => {
      this.setState({ data: data as any });
    });
  };

  private goGraph = () => {
    const { transaction, filter, router } = this.props;
    router.navigate(`/graph/${transaction}/${JSON.stringify(filter)}`);
  };

  private goConfiguration = () => {
    const { domain, router } = this.props;
    router.navigate(`/configuration/edit/${domain.name}`);
  };

  private onChangeInformationVisible = (visible: boolean) => {
    this.setState({ informationVisible: visible });
  };

  private getGraphMapKey = () => {
    const { data } = this.state;
    const { groups } = this.props;
    return (
      data && (
        <div
          className={
            'flex gap-x-2 box-border border-t rounded-xl border-b-none rounded-t-none border-[##E0E4E8] bg-main-gray h-12 items-center justify-start px-5  overflow-x-scroll custom-scroll absolute bottom-0 left-0 w-full  '
          }
        >
          {groups.map((item, index) => {
            return (
              <div key={index} className={'inline-flex items-center gap-x-2 px-5 py-2 shrink-0'}>
                <div className={'w-4 h-4 rounded-full'} style={{ backgroundColor: item.icon }}></div>
                <span className={'text-f-black-2 text-xs'}>{item.label}</span>
              </div>
            );
          })}
        </div>
      )
    );
  };

  private onExport = async () => {
    const { data } = this.state;
    const { transaction, groups, filter } = this.props;
    const _response = cloneDeep(data);
    delete _response.links;
    _response.nodes.map((node: any) => delete node.gfx);
    try {
      const job: GraphExportJob = {
        type: 'GRAPH_EXPORT',
        timestamp: moment().valueOf(),
        status: 'PENDING',
        graphResponse: _response,
        transactionId: transaction,
        groups: groups?.map((item) => ({ label: item.label, field: item.field })),
        filter,
        extension: 'csv',
        path: '',
      };
      await this.jobService.schedule(job);
      MessageUtil.success({
        summary: 'Export',
        detail: <div>Export job scheduled</div>,
      });
    } catch (e) {
      console.error(e);
    }
  };

  private onReport = async () => {
    const { data } = this.state;
    const { transaction } = this.props;
    if (data == undefined) return;
    this.setState({ reportLoading: true });
    const nodes = data.nodes?.map((node: any) => {
      return { field: node.group, value: node.label };
    });
    const transactionData = await this.caseService.executeSAR(nodes, transaction);
    this.setState({ transactionData: transactionData, reportVisible: true, reportLoading: false });
  };
}

class State {
  data: { nodes: []; links: [] } | undefined = undefined;
  informationVisible: boolean = false;
  selectedNode: GraphInformationJsonModel | undefined = undefined;
  coordinates: { x: number; y: number } = { x: 0, y: 0 };
  reportVisible: boolean = false;
  transactionData: TransactionData[] = [];
  reportLoading: boolean = false;
}

interface Props extends FormicaProps, ReduxProps {
  transaction: string;
  groups: CaseGraphField[];
  filter: Filter;
  transactionAmountField?: string;
  currencyConfiguration?: string;
  domain: CaseSettings;
  riskType: TransactionRiskType;
}

const mapStateToProps = (state: RootState) => ({
  component: state.component as ComponentState,
});
const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(CaseGraphComponent));
